<template>
    <div class="screen">
        <div class="screen__line">
            <img
                :src="quizBlueLine"
                alt=""
            />
        </div>
        <div class="screen__inner">
            <h3 class="screen__header heading-tertiary">{{ question }}</h3>
            <div class="screen__counter">
                <p class="screen__text heading-tertiary">
                    <span class="current-page">{{ currentPage }}</span>
                    &nbsp;<span class="total-pages"> /{{ totalPages }}</span>
                </p>
            </div>
        </div>
        <form
            class="screen__form"
            @submit.prevent="onSend"
            @input="changeForm"
        >
            <div class="screen__form-item">
                <input
                    v-model="name"
                    class="screen__input"
                    :class="{ 'screen__input--error': nameError }"
                    type="text"
                    :placeholder="$t('__quiz_screen_6_placeholder_1')"
                    :disabled="isDataFixed"
                    @focus="onNameFocus"
                />
            </div>

            <div class="screen__form-item">
                <input
                    v-model="phone"
                    class="screen__input"
                    :class="{ 'screen__input--error': phoneError }"
                    type="text"
                    :placeholder="$t('__quiz_screen_6_placeholder_2')"
                    :disabled="isDataFixed"
                    @keydown="checkKeyDownOnlyNumeric($event)"
                    @focus="onPhoneFocus"
                />
            </div>

            <div class="screen__form-item">
                <input
                    v-model="email"
                    class="screen__input"
                    type="email"
                    :disabled="isDataFixed"
                    :placeholder="$t('__quiz_screen_6_placeholder_3')"
                />
            </div>

            <div class="screen__buttons">
                <button
                    class="screen__button btn btn-primary"
                    type="submit"
                    :disabled="isDataFixed"
                >
                    {{ $t('__quiz_button_analysis') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { SimpleValidator } from '../../utils/amo-form-helper';
import quizBlueLine from '../../assets/svg/quiz/quiz-blue-line.svg';

export default {
    props: {
        question: {
            type: String,
            required: true,
        },
        currentPage: {
            type: Number,
            required: true,
        },
        totalPages: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            name: '',
            phone: '',
            email: '',
            isSent: false,
            nameError: false,
            phoneError: false,
            isDataFixed: false,
            quizBlueLine,
        };
    },
    methods: {
        onNameFocus() {
            if (!this.name) {
                if (this.nameError) this.nameError = false;
            }
        },

        onPhoneFocus() {
            if (!this.phone) {
                if (this.phoneError) this.phoneError = false;
            }
        },

        checkKeyDownOnlyNumeric(event) {
            if (SimpleValidator.isOnlyNumericInput(event.key)) {
                event.preventDefault();
            }
        },

        formValidation() {
            let isValid = true;

            if (SimpleValidator.isEmpty(this.name)) {
                this.nameError = true;
                isValid = false;
            }
            if (SimpleValidator.isEmpty(this.phone) || SimpleValidator.isNotPhoneNumber(this.phone)) {
                this.phoneError = true;
                isValid = false;
            }

            return isValid;
        },

        onSend() {
            if (this.formValidation()) {
                this.$emit('next', {
                    name: this.name,
                    phone: this.phone,
                    email: this.email,
                });
            }
        },
        changeForm() {
            if (this.isSent) {
                this.isSent = false;
            }
        },
    },
};
</script>
